import React, { useEffect } from "react";
import MapStats from "../components/MapStats";

function StatsPreview() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MapStats />
    </div>
  );
}

export default StatsPreview;
